const unitSpacing = 10;
const coreSpacing = unitSpacing * 2;
const headerSpacing = 50;
const headerSpacingWide = headerSpacing + 20;

export default {
  unitSpacing,
  coreSpacing,
  headerSpacing,
  headerSpacingWide
};



// WEBPACK FOOTER //
// src/dialpad/components/common/styles/dimensions.js